import { call, put, takeLatest } from "redux-saga/effects";
import { fetchAll } from "../../../services/subject";
import {
  getAllSubjectStart,
  getAllSubjectSuccess,
  getAllSubjectFailure,
} from "../reducer";

export function* getAllSubject({ payload }) {
  const response = yield call(fetchAll, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getAllSubjectSuccess(raw));
  } else {
    yield put(getAllSubjectFailure(message || raw.error));
  }
}

export default function* onGetSubject() {
  yield takeLatest(getAllSubjectStart.type, getAllSubject);
}
